import React from "react";
import { useEffect } from "react";
import { auth } from "./firebase";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Home";
import { useStateValue } from "./StateProvider";
import Header from "./Header";
import Product from "./Product";
import Login from "./Login";
import Checkout from "./Checkout";
import Orders from "./Orders";
import Order from "./Order";
import Payment from "./Payment";
function App() {
  const [{}, dispatch] = useStateValue();
  
useEffect(() => {
  // will only run once when the app component loads...

  auth.onAuthStateChanged((authUser) => {
    console.log("THE USER IS >>> ", authUser);

    if (authUser) {
      // the user just logged in / the user was logged in

      dispatch({
        type: "SET_USER",
        user: authUser,
      });
    } else {
      // the user is logged out
      dispatch({
        type: "SET_USER",
        user: null,
      });
    }
  });
}, []);
return (
  <div className="app">
    <Router>
      <Switch>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/checkout">
        
          <Checkout />
       </Route>
       <Route path="/checkout">
        
          <Payment />
       </Route>
       <Route path="/orders">
          <Order />
       </Route>
      <Route path="/">
        <Header/>
        <Home/>
        <Product/>
      </Route>
      </Switch>
    </Router>
  </div>
);
}
export default App;
